import { BASE_URL } from "@/constants/config";

export const HISTORICAL_ENDPOINTS = {
  historical: `${BASE_URL}api/historical/`,
}
